import styled from 'styled-components';

const BaseCharacter = styled.img`
  position: absolute;
  bottom: 0;
  z-index: 200;
  width: auto;
  object-fit: contain;

  @media (min-width: 750px) {
    height: 50vh;
    min-height: 350px;
  }

  @media (max-width: 750px) {
    height: 45vh;
    min-height: 45vh;
  }
`;

export const FirstCharacter = styled(BaseCharacter)`
  right: 0;
  @media (min-width: 750px) {
    margin-right: 200px;
  }

  @media (max-width: 750px) {
    margin-right: 20px;
  }
`;

export const SecondCharacter = styled(BaseCharacter)`
  /* transform: scaleX(-1); */
  @media (min-width: 750px) {
    right: 0;
    margin-right: 360px;
  }

  @media (max-width: 750px) {
    margin-left: 20px;
  }
`;

export const Container = styled.div`
  position: absolute;
  transform: translateX(-50%);
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  z-index: 110;
  background: #fff;
  transition: all 0.4s;

  @media (min-width: 750px) {
    right: 0;
    bottom: 0;
    margin-bottom: 51vh;
    width: 330px;
  }

  @media (max-width: 750px) {
    left: 50%;
    width: 90%;
    bottom: 45vh;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > div {
    padding: ${({ theme }) => `0 ${theme.spacing['2xs']}`};

    p {
      font-size: 14px;
      letter-spacing: 0;
    }
  }
`;

const BaseArrow = styled.span`
  width: 0;
  height: 0;
  border-bottom: 30px solid transparent;
  border-top: 30px solid transparent;
  border-right: 30px solid #fff;
  bottom: -25px;
  right: 50%;
  transform: rotate(rotate);
  position: absolute;
  transition: all 0.4s;
`;

export const FirstArrow = styled(BaseArrow)`
  transform: rotate(-20deg);
`;

export const SecondArrow = styled(BaseArrow)`
  transform: rotate(-290deg);
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: ${({ theme }) => theme.spacing['2xs']};

  > div {
    display: flex;
    align-items: center;

    > span {
      font-weight: 700;
      font-size: 15px;
      line-height: 15px;
      letter-spacing: 0;
    }
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;

    background: none;
    border: none;
    cursor: pointer;

    transition: all 0.4s;

    &:hover {
      opacity: 0.6;
    }

    svg {
      height: 16px;
      width: 16px;
      stroke-width: 1px;
    }
  }
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: ${({ theme }) => theme.spacing['2xs']};

  > button {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: ${({ theme }) => `0 ${theme.spacing.xs}`};
    height: 24px;
    background: ${({ theme }) => theme.colors.onInfo};
    color: ${({ theme }) => theme.colors.info};
    border-radius: ${({ theme }) => theme.borderRadius.lg};
    border: 1px solid ${({ theme }) => theme.colors.info};
    white-space: nowrap;

    font-size: 13px;
    font-weight: 700;
    line-height: 14px;

    min-width: 65px;

    transition: all 0.5s;

    &:hover {
      filter: brightness(0.92);
    }
  }
`;
